<itl-wizard-page
  [isSinglePage]="true"
  [pageTitleTransPath]="'audit.info.title'"
  (cancelClicked)="close()"
  (doneClicked)="dismiss()"
>
  <ion-content>
    <canvas #signaturPad></canvas>
    <div class="footer">
      <p>{{ 'audit.node.signature.foot_note' | translate }}</p>
      <itl-button (click)="clear()">
        <span color="primary"> {{ 'audit.node.signature.clear' | translate }} </span>
      </itl-button>
    </div>
  </ion-content>
</itl-wizard-page>
